import * as v from '@badrap/valita'
import { api } from 'src/api'
import { encrypt } from 'src/utils/crypto'
import { getAdminPolicy, getConnectPolicy } from './policy'

export const createIAMUser = (params: {
  organization: string
  username: string
  api_version: string
  api_accessKey: string
  api_accessSecret: string
  api_region: string
  usergroup: string
  usernameforcreate: string
}) =>
  api({
    schema: v
      .object({
        result: v.literal('OK'),
        user: v.object({
          AccessData: v.object({
            UserName: v.string(),
            AccessKeyId: v.string(),
            Status: v.literal('Active'),
            SecretAccessKey: v.string(),
            CreateDate: v.string().chain((date) => v.ok(new Date(date))),
          }),
          userId: v.string(),
        }),
      })
      .chain((data) => v.ok(data.user)),
    method: 'POST',
    url: '/createIAMUser',
    body: params,
    withAuth: true,
  })

export const createIAMPolicy = (params: {
  organization: string
  username: string
  api_version: string
  api_accessKey: string
  api_accessSecret: string
  api_region: string
  policyname: string
  policy:
    | ReturnType<typeof getAdminPolicy>
    | ReturnType<typeof getConnectPolicy>
  usergroup: string
}) =>
  api({
    schema: v
      .object({
        result: v.literal('OK'),
        policy: v.object({
          PolicyName: v.string(),
          PolicyId: v.string(),
          Arn: v.string(),
          Path: v.string(),
          DefaultVersionId: v.string(),
          AttachmentCount: v.number(),
          PermissionsBoundaryUsageCount: v.number(),
          IsAttachable: v.boolean(),
          CreateDate: v.string().chain((date) => v.ok(new Date(date))),
          UpdateDate: v.string().chain((date) => v.ok(new Date(date))),
          Tags: v.array(
            v.object({
              Key: v.string(),
              Value: v.string(),
            }),
          ),
        }),
      })
      .chain((data) => v.ok(data.policy)),
    method: 'POST',
    url: '/createIAMPolicy',
    body: params,
    withAuth: true,
  })

export const attachIAMPolicy = (params: {
  organization: string
  username: string
  api_version: string
  api_accessKey: string
  api_accessSecret: string
  api_region: string
  policyarn: string
  usernameforpolicy: string
}) =>
  api({
    schema: v.object({
      result: v.literal('OK'),
    }),
    method: 'POST',
    url: '/attachIAMPolicy',
    body: params,
    withAuth: true,
  })

export const testSetup = (params: {
  organization: string
  username: string
  usergroup: string
  usernamefortest: string
}) =>
  api({
    schema: v.unknown(), // TODO:
    method: 'POST',
    url: '/testsetup',
    body: params,
    withAuth: true,
  })

export const createFullUserpool = (params: {
  organization: string
  username: string
  poolname: string
  domain: string
}) =>
  api({
    schema: v
      .object({
        result: v.literal('OK'),
        userpool: v.object({
          userpoolid: v.string(),
          userpoolarn: v.string(),
          userpoolregion: v.string(),
          clientid: v.string(),
          userpoolclientsecret: v.string(),
          cognitourl: v.string(),
        }),
      })
      .chain((data) => v.ok(data.userpool)),
    method: 'POST',
    url: '/createfulluserpool',
    body: params,
    withAuth: true,
  })

export const resyncSubscriptionProvisioning = (params: {
  organization: string
}) =>
  api({
    schema: v.object({ result: v.literal('OK') }),
    method: 'POST',
    url: '/resyncsubscriptionprovisioning',
    body: {
      ...params,
      check: encrypt(params.organization),
    },
    withAuth: false,
  })
